import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useStyles from "./../pages/desktop/patient/Common.style";

const YesNoDialog = props => {
    const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" className={classes.formLabelStyle}>
                    {props.text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onAnswer('yes')} color="primary">
                    Yes
                </Button>
                <Button onClick={props.onAnswer('no')} color="primary" autoFocus>
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default YesNoDialog;
